import jwt_decode from 'jwt-decode';

export interface ITokenType {
    permissions: string[];
}  

export const getDecodeToken = async (token: string) => {
    return jwt_decode<ITokenType>(token);
};